<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
      <b-card-header 
        header-bg-variant="white"
        header-border-variant="white">
          <h4 id="traffic" class="card-title mb-0">{{title}}</h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12" md="12" lg="4">
            <b-card no-body border-variant="white">
                <b-card-body>
                    <datepicker 
                      :inline="true"
                      v-model="fechaPicker"
                      :language="lang"
                      @selected="cambiaFecha"
                      ref="dateComponent"
                      ></datepicker>
                </b-card-body>
            </b-card>
            
          </b-col>

          <b-col sm="12" md="12" lg="8">
            <b-card no-body>
              <h4 slot="header">{{fechaTexto}}</h4>
              <b-card-body>
                <p v-if="noticias.length === 0"><i>No hay noticias capturadas...</i></p>

                <ul v-else class="list-unstyled">

                  <b-media tag="li" v-for="(element, index) in noticias" :key="index" style="min-height: 120px;">
                    <b-img slot="aside" blank-color="#abc" width="100" height="60" alt="placeholder" :src="imagenNoticia(index)" />
                    <div slot="aside" style="position: absolute; margin-top: 70px;">
                        
                        <b-button-group v-if="puedeModificar" size="sm" class="">
                            <b-button 
                                :variant="element.visible ? 'outline-success' : 'outline-secondary'"
                                v-b-tooltip.hover :title="element.visible ? 'Visible en la página' : 'No visible en la página'"
                                @click="cambiaVisible(index)">
                                <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                            </b-button>

                            <b-button 
                                v-if="puedeModificar"
                                variant="outline-secondary"
                                v-b-tooltip.hover title="Modificar noticia"
                                @click="modificaNoticia(element._id)">
                                <i class="fa fa-pencil fa-lg"></i>
                            </b-button>
                            <b-button 
                                v-if="puedeEliminar"
                                variant="outline-secondary"
                                @click="eliminaNoticia(index)"
                                v-b-tooltip.hover 
                                title="Eliminar noticia">
                                <i class="fa fa-trash fa-lg"></i>
                            </b-button>
                        </b-button-group>

                    </div>

                    <div style="text-align: justify;">
                        <b-link :to="'noticias/'+element._id">
                            <b-badge v-if="element.visible" class="pull-right" variant="success">Visible</b-badge>
                            <b-badge v-else class="pull-right" variant="danger">Oculta</b-badge>
                            <h5 class="mt-0 mb-1">{{element.titulo}}</h5>
                            <p v-html="textoPlano(element.descripcion)"></p>
                        </b-link>
                    </div>
                  </b-media>
                </ul>

              </b-card-body>
              <b-card-body>
                <b-button 
                  v-if="puedeAgregar"
                  variant="primary" 
                  size="sm" 
                  class="pull-right"
                  @click="agregarNoticia()">Agregar noticia</b-button>
              </b-card-body>
            </b-card>
            
          </b-col>

        </b-row>
      </b-card-body>
      
      
    </b-card>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import {es} from 'vuejs-datepicker/dist/locale'
import date from 'date-and-time';
date.locale('es');

export default {
  name: 'NoticiasMain',
  components: {
    Loader,
    Datepicker
  },
  computed:{
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    fechaTexto(){
      return date.format(this.fechaPicker,'dddd D de MMMM de YYYY');
    },
    puedeAgregar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 131) >= 0 )
            return true;
        else
            return false;
    },
    puedeModificar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 132) >= 0 )
            return true;
        else
            return false;
    },
    puedeEliminar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 133) >= 0 )
            return true;
        else
            return false;
    }
  },
  data: function () {
    return {
      title: this.$route.name,
      enviando: false,
      fechaPicker: new Date(),
      lang: es,
      noticias: []
    }
  },
  created(){
      this.enviando = true;
      //console.log(this.fechaPicker.toISOString());
      axios.get(this.httpURL+'/comsocial/noticias/buscar/'+this.fechaPicker,{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.noticias = res.data.noticias;
                  this.enviando = false;
              })
              .catch(error => {
                  this.enviando = false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
              });
  },
  methods: {
    imagenNoticia(index){
        return this.noticias[index].imagen.path ? this.httpURL+'/'+this.noticias[index].imagen.path : '/img/brand/logo_150_x_100px.png'
    },
    textoPlano(texto){
      let resumen = texto.replace(/<[^>]*>?/g, '');
      return resumen.slice(0,140)+'...';
    },
    cambiaFecha(){
      this.enviando = true;
      setTimeout(()=>{ 
        //console.log(this.fechaPicker);
        axios.get(this.httpURL+'/comsocial/noticias/buscar/'+this.fechaPicker,{headers:{token:this.sessionToken}})
            .then(res => {
                //console.log(res.data);
                this.noticias = res.data.noticias;
                this.enviando = false;
            })
            .catch(error => {
                this.enviando = false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: 'No se pudo establecer una conexión al servidor.' });
              }
            });
      },50);
    },
    agregarNoticia(){
      this.$router.push('noticias/agregar');
    },
    cambiaVisible(index){
      //if( this.puedeModificar ){
            this.enviando = true;
            let noticia = this.noticias[index];
            axios.put(this.httpURL+'/comsocial/noticias/visible/'+noticia._id,
                    {},
                    {headers: {token:this.sessionToken}})
                .then(res => {
                    noticia.visible = !noticia.visible;
                    this.enviando = false;
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                })
                .catch(error => {
                    this.enviando = false;
                    if(error.response){
                        this.error = error.response.data.mensaje;
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                    }
                });
        //}
    },
    modificaNoticia(id){
        this.$router.push('noticias/modificar/'+id);
    },
    eliminaNoticia(index){
        swal({
              icon: 'info',
              title: 'Área protegida',
              text: 'Esta acción requiere de tu contraseña:',
              content: {
              element: "input",
              attributes: {
              placeholder: "Ingrese...",
              type: "password",
          }
          },
              closeOnClickOutside: true,
              button: {
              text: "Confirmar",
              closeModal: false,
          },
      })
      .then(password => {
          if (!password){
              swal.close();
          }else{
              this.enviando = true;
              let noticia = this.noticias[index];
              axios.delete(this.httpURL+'/comsocial/noticias/'+noticia._id,
                      {data:{password},headers: {token:this.sessionToken}})
                  .then(res => {
                      swal.close();
                      this.enviando = false;
                      this.noticias.splice(index,1);
                      this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                  })
                  .catch(error => {
                      this.enviando = false;
                      swal.close();
                      if(error.response){
                          this.error = error.response.data.mensaje;
                          //console.log(error.response);
                          this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                              text: error.response.data.mensaje });
                      }else if( error.request){
                          this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                              text: 'No se pudo establecer una conexión al servidor.' });
                      }
                  });
          }
      });
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

a:link {
  color: black;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

a:visited {
  color: black;
}
  
</style>
